import { Box, Button, Stack, Typography } from '@mui/material';
import SocialAccountsSection from './SocialAccountsSection';

export default function SocialConnectionsPage() {
  return (
    <Box sx={{ maxWidth: 960, mx: 'auto', p: { xs: 2, md: 3 } }}>
      <Stack spacing={3}>
        <Typography variant="h4" component="h1">
          Account Connections
        </Typography>
        <SocialAccountsSection />
        <Button component="a" href="/auth/profile" sx={{ alignSelf: 'flex-start' }}>
          Return to Profile
        </Button>
      </Stack>
    </Box>
  );
}
